var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialMediaTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.6.667h2.454l-5.36 6.126 6.305 8.337h-4.937l-3.867-5.056L2.77 15.13H.315L6.05 8.576-.001.667h5.063l3.496 4.621zm-.86 12.994h1.359L4.323 2.058H2.865z"
})));
export default SvgSocialMediaTwitter;